import FactorIcon from "assets/icons/FactorIcon";
import shopIcon from "assets/svg/icon-menu-navbar.svg";
import BasicButton from "components/BasicInputs/BasicButton";
import ShopCart from "assets/icons/ShopCartIcon";
import axios from "../../../../axios/axios";
import {useDispatch, useSelector} from "react-redux";
import {errorDispatcher} from "helpers";

export default function Side(props: any) {
    const store = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const token = store.businessReducer.business?.token;
    const payPrice = (props.data?.state?.shopPrice || 0) + (props.data?.state?.shopPrice || 0) * (9 / 100);
    const tax = (props.data?.state?.shopPrice || 0) * (9 / 100);
    const state = props.shopState;

    async function handleSubmit() {
        const fd = {
            price: payPrice,
            features: {
                theme: state?.s2[state.activeTheme].title,
                items: state?.s3?.filter((x: any) => x.active)?.map((x: any) => x.title),
            },
        };

        try {
            const res = await axios.post("vitsell/buy", fd, {
                headers: {Authorization: `Bearer ${token}`},
            });
            const url = res.data.payment?.url;
            window.location.href = url;
        } catch (error) {
            errorDispatcher(error, dispatch, false);
        }
    }

    return (
        <div className="p-4 flex flex-col gap-6">
            <div className="p-4 rounded-md border border-slate-200 flex flex-col gap-4">
                <div className="flex items-center gap-2">
                    <FactorIcon/>
                    <span>محصولات</span>
                </div>
                <div className="flex items-center gap-2">
                    <img src={shopIcon} alt="" className="w-8 h-8"/>
                    <div className="flex flex-col gap-2">
                        <span>فروشگاه اینترنتی چرتکه</span>
                        <span className="text-xs text-dark-3">{props.data?.state?.shopTheme?.title}</span>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-6">
                <div className="flex items-center justify-between gap-4">
                    <span className="text-dark-2">قیمت</span>
                    <div className="flex items-center gap-2">
            <span className="text-dark-1">
              {Intl.NumberFormat().format(props.data?.state?.shopPrice || 0)}
            </span>
                        <span className="text-xs text-dark-3">تومان</span>
                    </div>
                </div>
                <div className="flex items-center justify-between gap-4">
                    <span className="text-dark-2">مالیات بر ارزش افزوده</span>
                    <div className="flex items-center gap-2">
                        <span className="text-dark-1">{Intl.NumberFormat().format(tax)}</span>
                        <span className="text-xs text-dark-3">تومان</span>
                    </div>
                </div>
                <div className="flex items-center justify-between gap-4">
                    <span className="text-dark-2 font-bold text-base">قابل پرداخت</span>
                    <div className="flex items-center gap-2">
                        <span className="text-dark-1 font-bold text-lg">{Intl.NumberFormat().format(payPrice)}</span>
                        <span className="text-xs text-dark-3">تومان</span>
                    </div>
                </div>
                <BasicButton variant="contained" className="my-4" onClick={handleSubmit}>
          <span>
            <ShopCart color="#fff"/>
          </span>
                    <span>خرید نرم افزار فروشگاهی چرتکه</span>
                </BasicButton>
            </div>
        </div>
    );
}
